import { useCallback } from 'react';
import { useQuery } from 'react-query';

import PostSaleService from '../../services/PostSaleService';
import { TERMS_AND_CONDITIONS } from '../constants/queryDefinition';
import Shipping from '../models/Shipping';
import ErrorService from '../../services/ErrorService';
import { COUNTRY_CODE } from '../constants/country';

interface IUseTermsAndConditions {
  dealerId?: number;
  isMultiOrgAndEnabled: boolean;
  modalIsOpen: boolean;
  shippingEstimateResponse: Shipping;
  tradeId: number;
}

const useTermsAndConditions = ({
  dealerId,
  isMultiOrgAndEnabled,
  modalIsOpen,
  shippingEstimateResponse,
  tradeId
}: IUseTermsAndConditions) => {
  const getTermsAndConditions = useCallback(async () => {
    try {
      const isShippingPromotion = Shipping.isShippingPromotion(
        shippingEstimateResponse
      );
      const termsAndConditions = await PostSaleService.getRateInfoTermsAndConditions(
        isShippingPromotion
      );

      return Shipping.formatTermsAndConditons(
        termsAndConditions,
        isShippingPromotion
      );
    } catch (e) {
      ErrorService.trackError(e);
      return new Shipping(null, COUNTRY_CODE.CA);
    }
  }, [shippingEstimateResponse]);

  return useQuery(
    [TERMS_AND_CONDITIONS.KEY, tradeId, dealerId],
    getTermsAndConditions,
    {
      enabled: !!(tradeId && dealerId && modalIsOpen),
      staleTime: TERMS_AND_CONDITIONS.REFETCH_INTERVAL,
      retry: false
    }
  );
};

export default useTermsAndConditions;
